/**
 * Componente AdminRoute
 * Rota protegida que requer role ADMIN ou ADMINISTRATIVO e aplica layout
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import AppLayout from "../layout/AppLayout";
import AccessDeniedState from "./AccessDeniedState";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading, granularPermissionsEnabled, hasEffectivePermission } = useAuth();
  const location = useLocation();

  // Aguarda verificação de autenticação
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  // Se não estiver autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Modo granular: usa permissão efetiva para acesso administrativo de usuários.
  if (granularPermissionsEnabled) {
    if (!hasEffectivePermission("usuarios.usuario.visualizar")) {
      return (
        <AppLayout>
          <AccessDeniedState
            description="Você não tem permissão administrativa para acessar esta área."
          />
        </AppLayout>
      );
    }
  }

  // Fallback legado por role.
  if (!granularPermissionsEnabled && user?.role !== "ADMIN" && user?.role !== "ADMINISTRATIVO" && user?.role !== "TECNICO_GERAL" && user?.role !== "TECNICO") {
    return (
      <AppLayout>
        <AccessDeniedState
          description="Seu perfil não tem acesso administrativo a esta área."
        />
      </AppLayout>
    );
  }

  // Renderiza com layout (apenas uma vez)
  return <AppLayout>{children}</AppLayout>;
};

export default AdminRoute;
